import client from './client';

export const heartbeatsApi = {
  async list(appId) {
    const { data } = await client.get(`/api/alert-apps/${appId}/heartbeats`);
    return data;
  },

  async del(appId, id) {
    const { data } = await client.delete(`/api/alert-apps/${appId}/heartbeats/${id}`);
    return data;
  },
};
